import { Component } from '@angular/core';

@Component({
  selector: 'slender-authenticated-route-container',
  template: '<router-outlet></router-outlet>'
})
export class MainComponent { }
